import { Header } from './header';

/**
* Environment class is used in Unify to store information about the Environment the user is in.
* @example 
*      var environment = new Environment(true);
* @param {object} o options
* @param {string} o.translations translations object
* @param {string} o.isATestEnvironment if it is a test environment. Top-bar test indication 
*/
export class Environment {
    constructor(o) {
        o = typeof o !== 'undefined' ? o : {};
        this.isATestEnvironment = typeof o.isATestEnvironment !== 'undefined' ? o.isATestEnvironment : true;
        this.translations = o.translations;

        if (typeof this.translations === 'undefined') {
            throw 'Environment class called without property translations';
        }
    }

    setSystemInformation(json) {
        if (typeof json === "undefined" || typeof json.Environment === "undefined") {
            this.type = 'Unknown';
            return;
        }
        this.type = json.Environment;
        this.isATestEnvironment = json.Environment !== 'Production';

        var header = new Header({
            translations: this.translations
        });
        header.updateIsATestEnvironmentLayout(this.isATestEnvironment);
    }

    /**
    * updateEnvironmentVariables updates the environment variables
    */
    updateEnvironmentVariables() {
        // if contains .soderbergpartners.se and not test.soderbergpartners.se it is live
        var hostname = '' + window.location.hostname;
        if (hostname.indexOf('.soderbergpartners.se') > 0 && hostname.indexOf('test.soderbergpartners.se') === -1) {
            this.isATestEnvironment = false;
        }
    }
}
